module.exports = __webpack_public_path__ + "static/turquia-024.thumb-6ee12adbfc04de16afb75b894b85537b.jpg";